import { render, staticRenderFns } from "./configuration-automation-assays-modal-relationships.vue?vue&type=template&id=05f2aa70&scoped=true&"
import script from "./configuration-automation-assays-modal-relationships.ts?vue&type=script&lang=ts&"
export * from "./configuration-automation-assays-modal-relationships.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-automation-assays-modal-relationships.scss?vue&type=style&index=0&id=05f2aa70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f2aa70",
  null
  
)

export default component.exports